import type {
	CustomItem,
	DropWhatsappButtonType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropWhatsappButton = (
	item: Item | CustomItem
): item is DropWhatsappButtonType => {
	return !!(item && item.__typename === 'Drop_Whatsapp_Button');
};
